import { createStore } from "vuex";
import profile from "./profile.js";
import comments from "./comments.js";
import news from "./news.js";
import { useAuthStore } from "./auth.js";
import { useGlobalStore } from "./global.js";
import { useSystemSettingsStore } from "./system-settings.js";
import { useSessionStore } from "./session-store.js";
import { useGoogleMapsStore } from "./google-maps.js";
const store = createStore({
  modules: {
    profile,
    comments,
    news
  }
});
export {
  store as default,
  useAuthStore,
  useGlobalStore,
  useGoogleMapsStore,
  useSessionStore,
  useSystemSettingsStore
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdG9yZS9pbmRleC5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjcmVhdGVTdG9yZSB9IGZyb20gXCJ2dWV4XCI7XG5cbmltcG9ydCBwcm9maWxlIGZyb20gXCIuL3Byb2ZpbGVcIjtcbmltcG9ydCBjb21tZW50cyBmcm9tIFwiLi9jb21tZW50c1wiO1xuaW1wb3J0IG5ld3MgZnJvbSBcIi4vbmV3c1wiO1xuXG5leHBvcnQgZGVmYXVsdCBjcmVhdGVTdG9yZSh7XG5cdG1vZHVsZXM6IHtcblx0XHRwcm9maWxlLFxuXHRcdGNvbW1lbnRzLFxuXHRcdG5ld3MsXG5cdH0sXG59KTtcblxuZXhwb3J0IHsgdXNlQXV0aFN0b3JlIH0gZnJvbSBcIi4vYXV0aFwiO1xuZXhwb3J0IHsgdXNlR2xvYmFsU3RvcmUgfSBmcm9tIFwiLi9nbG9iYWxcIjtcbmV4cG9ydCB7IHVzZVN5c3RlbVNldHRpbmdzU3RvcmUgfSBmcm9tIFwiLi9zeXN0ZW0tc2V0dGluZ3NcIjtcbmV4cG9ydCB7IHVzZVNlc3Npb25TdG9yZSB9IGZyb20gXCIuL3Nlc3Npb24tc3RvcmVcIjtcbmV4cG9ydCB7IHVzZUdvb2dsZU1hcHNTdG9yZSB9IGZyb20gXCIuL2dvb2dsZS1tYXBzXCI7XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBTUEsTUFBQSxRQUFlLFlBQVk7QUFBQSxFQUMxQixTQUFTO0FBQUEsSUFDUjtBQUFBLElBQ0E7QUFBQSxJQUNBO0FBQUEsRUFDQTtBQUNGLENBQUM7In0=
